"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileTrayOverlay = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const shared_1 = require("../../shared");
const Styled = styled_components_1.default.div `
	position: fixed;
	z-index: 9000;
	background: #000;
	opacity: 0.2;
	bottom: 0;
	left: 0;
	right: 0;
	top: ${(p) => p.theme.navHeight + p.topOffset}px;
`;
const MobileTrayOverlay = ({ topOffset }) => {
    const { mobileMenuOpen } = (0, shared_1.useMobileMenu)();
    const closeMenus = (0, shared_1.useCloseAllMenus)();
    const closeMobileMenu = (0, react_1.useCallback)(() => {
        closeMenus();
    }, [mobileMenuOpen, closeMenus]);
    if (!mobileMenuOpen)
        return null;
    return react_1.default.createElement(Styled, { onClick: closeMobileMenu, topOffset: topOffset });
};
exports.MobileTrayOverlay = MobileTrayOverlay;
//# sourceMappingURL=MobileTrayOverlay.js.map